import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsDeleteAuthSession = z.any()
export type TagsDeleteAuthSession = z.infer<typeof tagsDeleteAuthSession>

export const responseDeleteAuthSession = z.any()
export type ResponseDeleteAuthSession = z.infer<typeof responseDeleteAuthSession>

interface IDeleteAuthSession extends BaseMethodType {
  tags: TagsDeleteAuthSession,
  response: ResponseDeleteAuthSession
}
export const URL = '/auth/session'
export const validation = {
  delete: {
    tags: tagsDeleteAuthSession,
    response: responseDeleteAuthSession
  }
}
export interface AuthSession extends BaseRouteType {
  delete: IDeleteAuthSession
}